import type { ShippingOtp, PostOtpParams } from '../types/otp.type';
import { OTP_BUSINESS_FLOWS_WITH_RECAPTCHA } from '../constants/otpRecaptcha.constant';

/**
 * Generates the payload and headers for OTP requests, handling new vs legacy flow logic.
 * 
 * @param type - OTP delivery channel (SMS, EMAIL, WHATSAPP)
 * @param businessFlow - Associated business flow
 * @param recaptcha - Object with reCAPTCHA token and version
 * @returns Object with `data` (payload) and `headers` ready to use in the service
 */
export function getOtpPayload(
  type: ShippingOtp,
  businessFlow: string,
  recaptcha?: { token: string; version: 'V2' | 'V3' }
): { data: PostOtpParams; headers: Record<string, string> } {
  const isNewFlow = (OTP_BUSINESS_FLOWS_WITH_RECAPTCHA as readonly string[]).includes(
    businessFlow
  );

  if (isNewFlow) {
    return {
      data: {
        channel: type,
        businessFlow,
        recaptchaInfo: {
          token: recaptcha?.token ?? '',
          version: recaptcha?.version ?? 'V3',
        },
      },
      headers: { 'X-API-VERSION': '2' },
    };
  }

  return {
    data: {
      channel: type,
      business_flow: businessFlow,
      token: recaptcha?.token,
    },
    headers: {},
  };
}
